import { render } from "./Box.vue?vue&type=template&id=626d12ab&scoped=true"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"

import "./Box.vue?vue&type=style&index=0&id=626d12ab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-626d12ab"

export default script